export class PersonElector {
    id: number;
    number: number;
    zone: string;
    section: string;
}